import { AgGridReact } from 'ag-grid-react';
import { GridWrapper } from './styles';
import { ColDef, ColGroupDef, FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, IHeaderParams, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { IOnTimeKidneyPickup } from '@nkr/models/index';
import { Glyphicon } from 'react-bootstrap';
import { useMemo } from 'react';
import { Utility } from '@nkr/services/utility';
import CenterAlias from '@nkr/views/center-admin/action-center/pending-swaps/center-alias';

interface IProps {
    data: IOnTimeKidneyPickup[],
    centerId: number,
    isCenterLogin?: boolean
}

const Grid = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onSortChanged = (e: SortChangedEvent) => {

    };

    type MyColDef = ColDef | ColGroupDef;

    const columns: MyColDef[] = [
        {
            colId: 'Rank',
            headerName: 'R#',
            width: 55,
            sortable: false,
            resizable: true,
            suppressSizeToFit: true,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>R#</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1,
        },
        {
            colId: 'swapNumber',
            field: 'swapNumber',
            headerName: 'swapNumber',
            width: 75,
            resizable: true,
            suppressSizeToFit: true,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Swap #</SortableHeaderComponent>,
        },
        {
            groupId: 'donor',
            headerName: 'Donor',
            headerClass: 'group-header',
            children: [
                {
                    colId: 'donorCenter',
                    field: 'donorCenter',
                    headerName: 'Donor Center',
                    width: 120,
                    comparator: Utility.stringSortComparator,
                    headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Center</SortableHeaderComponent>,
                    cellRendererFramework: (params: ICellRendererParams) => {
                        let data = params.data as IOnTimeKidneyPickup;


                        if (data.remoteDonorCenterId != null && data.remoteDonorCenterId > 0) {
                            return (
                                <>{data.donorCenter} <span style={{ color: 'red' }}>(<a href={`/center/${data.remoteDonorCenterId}/reports/my-center/on-time-kidney-pickup-detail`} target='_blank'>{data.remoteDonorCenter}</a>)</span></>
                            );
                        }


                        if (data.donorCenterId == props.centerId) {
                            return (
                                <a href={`center/${props.centerId}/profile/edit`} target='_blank'>{data.donorCenter}</a>
                            );
                        }


                        return (
                            <a href={`/center/${data.donorCenterId}/reports/my-center/on-time-kidney-pickup-detail`} target='_blank'>{data.donorCenter}</a>
                        );

                    }

                },
                {
                    colId: 'donorAlias',
                    field: 'donorAlias',
                    headerName: 'Donor Alias',
                    width: 120,
                    headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Alias</SortableHeaderComponent>,
                },
            ]
        },
        {
            groupId: 'recipient',
            headerName: 'Recipient',
            headerClass: 'group-header',
            children: [

                {
                    colId: 'recipientCenter',
                    field: 'recipientCenter',
                    headerName: 'Recipient Center',
                    width: 120,
                    comparator: Utility.stringSortComparator,
                    headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Center</SortableHeaderComponent>,
                },
                {
                    colId: 'recipientAlias',
                    field: 'recipientAlias',
                    headerName: 'Recipient Alias',
                    width: 120,
                    headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Alias</SortableHeaderComponent>,
                },
            ]
        },
        {
            colId: 'scheduledPickup',
            field: 'scheduledPickup',
            headerName: 'Offer',
            width: 120,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Scheduled Pickup</SortableHeaderComponent>,
            comparator: Utility.dateComparator
        },
        {
            colId: 'actualPickup',
            field: 'actualPickup',
            headerName: 'Deadline',
            width: 120,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Actual Pickup</SortableHeaderComponent>,
            comparator: Utility.dateComparator
        },
        {
            colId: 'transportationType',
            field: 'transportationType',
            headerName: 'Decision',
            width: 120,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Transport Type</SortableHeaderComponent>,
        },
        {
            colId: 'no-response',
            headerName: 'On Time',
            width: 85,
            resizable: true,
            suppressSizeToFit: true,
            headerClass: 'header-row-span-2-left-right',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>On Time</SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IOnTimeKidneyPickup;

                if (data.onTime) {
                    return (
                        <Glyphicon glyph='ok' />
                    )
                }

                return null;
            },
            valueGetter: (params: ValueGetterParams) => {
                let data = params.data as IOnTimeKidneyPickup;

                if (data.onTime) {
                    return 1;
                }
                return 2;
            }
        },
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ marginBottom: 20 }}>
            <AgGridReact
                defaultColDef={{
                    cellClass: 'list-cell',
                    headerClass: 'list-header',
                    sortable: true,
                    resizable: true
                }}
                columnDefs={columnDefs}
                rowData={rowData}
                enableCellTextSelection={true}
                enableRangeSelection={true}
                headerHeight={32}
                noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                suppressCellSelection={true}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                onSortChanged={onSortChanged}
            />
        </GridWrapper>
    );
}

export default Grid;